import React, { useEffect, useMemo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import { IconButton } from "@mui/material";
import { useAlert } from "../../../context/AlertContext";
import { refreshClientPackages } from "../../../data/membersStore";
const SideBarTest = ({
  isOpen,

  client_id,
  closeSearch,
  setActiveReschedule,
  toggleSidebar,
  closeSidebar,
  appointments,
  activeReschedule,
  appointmentsAll,
  refresh,
  openPopup,
  setOpenAgenda,
  setDeletePopUp,
  checkCard,
  activeClientInformation,
  setActiveClientInformation,
}) => {
  const [clientData, setClientData] = useState(null);
  const [clientAppointments, setClientAppointments] = useState(null);

  const [agendaData, setAgendaData] = useState([]);

  const [bookingAdded, setBookingAdded] = useState(false);
  const { showAlert } = useAlert();

  const realAppointments =
    appointments &&
    Object.values(appointments)
      .filter((appointment) => appointment.checked)
      .filter((value, index, self) => {
        return index === self.findIndex((t) => t.id === value.id);
      });
  useEffect(() => {
    if (appointmentsAll && typeof appointmentsAll === "object") {
      const appointmentsWithClients = Object.values(appointmentsAll).filter(
        (appointment, index) => {
          if (appointment.bookings_client) {
            if (Array.isArray(appointment.bookings_client)) {
              if (appointment.checked) {
                return appointment;
              }
              return appointment.bookings_client.some(
                (client) => client.client_id === client_id
              );
            }

            return appointment.bookings_client.client_id === client_id;
          }
          return false;
        }
      );

      let sortedAppointments = appointmentsWithClients.sort(
        (a, b) =>
          moment(a.start, "YYYY-MM-DD HH:mm:ss").valueOf() -
          moment(b.start, "YYYY-MM-DD HH:mm:ss").valueOf()
      );

      let sortNoShow = sortedAppointments.filter(
        (app) =>
          app.bookings_client?.length > 0 &&
          app.bookings_client[0].status !== "noshow"
      );

      const agendaGroupsIndexes = {};
      const agendaGroups = [];
      sortNoShow.forEach((c) => {
        const mDate = moment(c.start);
        c.week = mDate.week();
        if (agendaGroupsIndexes.hasOwnProperty(c.week) == false) {
          agendaGroupsIndexes[c.week] = [];
          agendaGroupsIndexes[c.week].weekNum =
            mDate.isoWeek() - mDate.clone().startOf("month").isoWeek() + 1;

          agendaGroupsIndexes[c.week].weekStart = mDate
            .clone()
            .startOf("week")
            .format("YYYY-MM-DD");
          agendaGroupsIndexes[c.week].weekEnd = mDate
            .clone()
            .endOf("week")
            .format("YYYY-MM-DD");
          agendaGroups.push(agendaGroupsIndexes[c.week]);
        }
        agendaGroupsIndexes[c.week].push(c);
      });

      setClientAppointments(agendaGroups);
    }
  }, [client_id, appointmentsAll]);

  const closeBoth = (e) => {
    e.stopPropagation();
    toggleSidebar();
    closeSidebar();
    setActiveClientInformation(null);
  };
  const addBooking = async () => {
    try {
      const timeSlots = Object.keys(realAppointments).map((appointment) => ({
        client_id: client_id,
        status: realAppointments[appointment].bookings_client.length
          ? "canceled"
          : "book",
        start: new Date(realAppointments[appointment].start),
        timeSlot_id: realAppointments[appointment].id,
      }));

      const data = {
        timeSlots: timeSlots,
      };

      const response = await ApiMethods.post(
        "auth/add_booking_cancelation",
        data
      );
      // All of `timeSlots` above belong to this one client — one refresh covers them all.
      refreshClientPackages(client_id);
      refresh();
      setBookingAdded((prev) => !prev);
    } catch (err) {
      if (err?.code === "NO_AVAILABLE_PACKAGE") {
        showAlert(err.message, "error");
      } else {
        showAlert("Došlo je do greške pri izmeni termina", "error");
      }
    }
  };

  const toggleFakeContainer = (e) => {
    e.stopPropagation();
    setActiveReschedule();
  };
  const formatDateAndTime = (dateString) => {
    const date = new Date(dateString);

    const formattedDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;

    const formattedTime = `${date.getHours()}:${
      date.getMinutes() < 10 ? "0" : ""
    }${date.getMinutes()}`;

    return { formattedDate, formattedTime };
  };
  const agendaInformation = async () => {
    try {
      console.log(client_id, "client id");
      const response = await ApiMethods.get(
        `auth/agenda_information/${client_id}`
      );
      const updatedAgenda = response.agenda.map((item) => ({
        ...item,
        checked: false,
      }));

      response.agenda.forEach((record) => {
        record.checked = false;
      });
      const agendaGroupsIndexes = {};
      const agendaGroups = [];
      console.log(response.agenda, "agenda");
      response.agenda.forEach((c) => {
        const mDate = moment(c.start);
        c.week = mDate.week();
        if (agendaGroupsIndexes.hasOwnProperty(c.week) == false) {
          agendaGroupsIndexes[c.week] = [];
          agendaGroupsIndexes[c.week].weekNum = c.week;
          agendaGroupsIndexes[c.week].weekStart = mDate
            .clone()
            .startOf("week")
            .format("YYYY-MM-DD");
          agendaGroupsIndexes[c.week].weekEnd = mDate
            .clone()
            .endOf("week")
            .format("YYYY-MM-DD");
          agendaGroups.push(agendaGroupsIndexes[c.week]);
        }
        agendaGroupsIndexes[c.week].push(c);
      });
      setClientData(response.client);

      setAgendaData(agendaGroups);
    } catch (err) {
      console.error("Error fetching agenda information:", err);
    }
  };

  return (
    <div
      style={{ overflow: "hidden", zIndex: "10000000000000" }}
      className={`drawer-main-container ${
        client_id ? "drawer-open" : ""
      } mobile-drawer`}
    >
      <div
        style={{
          display: "flex",
          gap: "5px",
          height: "auto",
          justifyContent: "space-evenly",
        }}
      >
        <IconButton onClick={setDeletePopUp}>
          <DeleteIcon sx={{ fontSize: "35px" }} style={{ color: "#E55050" }} />
        </IconButton>
        <IconButton>
          <EditIcon
            sx={{ fontSize: "35px" }}
            onClick={openPopup}
            style={{ color: "#353839" }}
          />
        </IconButton>
        <IconButton>
          <CloseIcon
            sx={{ fontSize: "35px" }}
            style={{ color: "#353839" }}
            onClick={closeBoth}
          />
        </IconButton>
        <IconButton>
          <WorkHistoryIcon
            sx={{ fontSize: "35px" }}
            style={{ color: "#353839" }}
            onClick={setOpenAgenda}
          />
        </IconButton>
      </div>
      <hr />
      <div
        style={{
          height: "auto",
          marginTop: "30px",
          padding: "0px 10px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <div
          className={`button-card 
                }`}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ padding: "7px 4px" }} className="booking-info">
            <span
              style={{
                display: "flex",
                backgroundColor:
                  activeClientInformation && activeClientInformation.gender
                    ? activeClientInformation.gender === "Male"
                      ? "#97dfff"
                      : activeClientInformation.gender === "No"
                      ? "#adb5bd"
                      : "#FF8E8B"
                    : "transparent",
                stroke: "black",
                border: "1px solid black",
                strokeWidth: "0.5px",
              }}
              className="circle-card"
            ></span>

            <span
              style={{
                textTransform: "uppercase",
                color: "#000",
              }}
              className="name-client sidebar-name"
            >
              {activeClientInformation && activeClientInformation.first_name}{" "}
              {activeClientInformation && activeClientInformation.last_name}
            </span>
          </div>
        </div>
        <div className="contact-details">
          <div className="info-contact-1">
            <CakeOutlinedIcon
              sx={{ fontSize: "15px" }}
              style={{ color: "black" }}
            />
            <div className="info-contact-row-1">
              <span className="sidebar-info-user" style={{ color: "#404040" }}>
                {" "}
                {activeClientInformation?.birthday
                  ? activeClientInformation.birthday
                  : "N/A"}
              </span>
            </div>
          </div>

          <div className="info-contact-1">
            <EmailOutlinedIcon
              sx={{ fontSize: "15px" }}
              style={{ color: "black" }}
            />

            <span
              className="sidebar-info-user"
              style={{
                color: "#404040",

                maxWidth: "120px",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {activeClientInformation?.email
                ? activeClientInformation.email
                : "N/A"}
            </span>
          </div>
          <div className="info-contact-1">
            <LocalPhoneOutlinedIcon
              sx={{ fontSize: "15px" }}
              style={{ color: "black" }}
            />

            <span className="sidebar-info-user" style={{ color: "#404040" }}>
              {activeClientInformation?.phone
                ? activeClientInformation.phone
                : "N/A"}
            </span>
          </div>
        </div>
      </div>

      <div className="sidebar-content">
        {clientAppointments && clientAppointments.length > 0 && (
          <>
            {clientAppointments.map((weekData, index) => {
              return (
                <div
                  style={{
                    height: "100%",
                    overflow: "scroll",
                    paddingBottom: "140px",
                    width: "100%",
                  }}
                  key={index}
                >
                  <div
                    style={{
                      height: "auto",
                      padding: "8px",
                    }}
                  >
                    <span
                      style={{
                        color: "black",
                        fontSize: "12px",
                        fontWeight: "700",
                      }}
                    >
                      <span style={{ fontSize: "14px" }}>
                        NEDELJA {weekData.weekNum}
                      </span>

                      {"  "}
                    </span>
                    <span
                      style={{
                        color: "black",
                        fontSize: "11px",
                        fontWeight: "500",
                      }}
                    >
                      ({weekData.weekStart})
                    </span>
                  </div>

                  <div
                    className="card-sidebar"
                    style={{
                      overflow: "auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {weekData.map((item) => {
                      if (!item.weekNum) {
                        const startDate = new Date(item.start);
                        const endDate = new Date(item.end);
                        const startOfToday = moment().startOf("day");
                        const isPastDayAndHour = moment(startDate)
                          .startOf("hour")
                          .isBefore(moment().startOf("hour"));
                        const isToday = moment(startDate).isSame(
                          startOfToday,
                          "day"
                        );

                        const dayOfWeek = startDate.toLocaleString("sr-Latn", {
                          weekday: "long",
                        });

                        const formattedDate = `${
                          startDate.getMonth() + 1
                        }/${startDate.getDate()}/${startDate.getFullYear()}`;
                        const startTime = `${startDate.getHours()}:${
                          startDate.getMinutes() < 10 ? "0" : ""
                        }${startDate.getMinutes()}`;
                        const endTime = `${endDate.getHours()}:${
                          endDate.getMinutes() < 10 ? "0" : ""
                        }${endDate.getMinutes()}`;

                        return (
                          <div
                            onClick={() => {
                              if (activeReschedule) {
                                console.log(
                                  item.bookings_client,
                                  "Item bookingclient"
                                );
                                checkCard(item.start, item.id, item);
                              }
                            }}
                            key={item.id}
                            style={{
                              color: "red",
                              borderRadius: "15px",
                              padding: "10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                              height: "auto",
                              borderBottom: "1px solid #ccc",
                              paddingBottom: "10px",
                              backgroundColor:
                                item.bookings_client.length == 0 && item.checked
                                  ? "rgb(208, 238, 198)"
                                  : item.checked
                                  ? "rgba(255, 0, 0, 0.2)"
                                  : "white",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                gap: "7px",
                                justifyContent: "space-between",
                                width: "95%",
                                textTransform: "uppercase",

                                textDecoration: item.bookings_client
                                  ? "white"
                                  : item.checked
                                  ? "line-through"
                                  : "none",
                              }}
                            >
                              <span
                                style={{
                                  color: "black",
                                  fontSize: "15px",
                                  fontWeight: "700",
                                }}
                              >
                                {dayOfWeek}
                              </span>

                              <span
                                style={{
                                  color: "black",
                                  fontSize: "13px",
                                  fontWeight: "400",
                                }}
                              >
                                {formattedDate}
                              </span>
                            </div>
                            <div
                              style={{
                                fontSize: "13px",

                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                                color:
                                  item.bookings_client.length == 0 &&
                                  item.checked
                                    ? "black"
                                    : item.checked
                                    ? "black"
                                    : "#A1A1AA",
                              }}
                            >
                              <span
                                style={{
                                  backgroundColor: isPastDayAndHour
                                    ? "#A6A6A6"
                                    : isToday
                                    ? "#e4322d"
                                    : " #FFCDB2",
                                }}
                                className="little-circle"
                              ></span>{" "}
                              {startTime} - {endTime}
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>
              );
            })}
          </>
        )}

        {activeReschedule ? (
          <div
            className="bottom-sidebar"
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <button onClick={closeBoth} className="close-change-booking">
              Otkaži
            </button>
            <button onClick={addBooking} className="reschedule-change-booking">
              Sačuvaj
            </button>
          </div>
        ) : (
          <div className="bottom-sidebar">
            <button className="scheduler-sidebar" onClick={toggleFakeContainer}>
              Zakazati / Promeniti
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SideBarTest;
